import axios from "axios";

// Deliberately NOT the shared rootClient from src/api/api.js — that client's
// interceptor reads a logged-in session's accessToken from localStorage and
// handles refresh/retry, none of which applies to a kiosk that never logs in.
// This talks to its own isolated /api/v1/display prefix (see medipro-backend's
// routes/display.js) using the credential embedded in the page's own URL.
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// `code` is the current short-code format (?code=ABC123 — easy to type on a
// TV remote); `token` is the older long-lived JWT format (?token=...), kept
// working for any link pasted into a TV before the short-code format existed.
export const getQueue = ({ code, token }) =>
  axios
    .get(`${BASE_URL}/api/v1/display/queue`, {
      params: code ? { code } : { authorization: `Bearer ${token}` },
    })
    .then((res) => res.data);
